import { AppContextType } from 'common/context/AppContext'

interface EntityWithModified {
    modified?: unknown
}

interface QueueListRepositionOnModifiedChangeArgs {
    appContext: AppContextType
    routeKey: string
    previousEntity?: EntityWithModified | null
    responseEntity?: EntityWithModified | null
    enabled?: boolean
}

function getModifiedValue(value?: EntityWithModified | null) {
    return value?.modified ? String(value.modified) : undefined
}

export function queueListRepositionOnModifiedChange({
    appContext,
    routeKey,
    previousEntity,
    responseEntity,
    enabled = true
}: QueueListRepositionOnModifiedChangeArgs) {
    if (!enabled) {
        return false
    }

    const previousModified = getModifiedValue(previousEntity)
    const currentModified = getModifiedValue(responseEntity)

    if (previousModified === undefined || currentModified === undefined || previousModified === currentModified) {
        return false
    }

    const pendingListNavigation = new Map(appContext.pendingListNavigation)
    pendingListNavigation.set(routeKey, { repositionByModifiedDate: true })
    appContext.setPendingListNavigation(pendingListNavigation)

    return true
}
